import React, {Dispatch, SetStateAction, useState} from "react";
import MainLayout from "@/pages/auth/Login/components/MainLayout";
import {ReactComponent as LayoutImage} from "@/assets/images/UserLogin.svg"
import {
  Button,
  Grid,
  Typography
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {object, TypeOf, z} from "zod";
import WebURL from "@/urls";
import {useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {useSnackbar} from "notistack";
import UserService from "@/services/auth/UserService";

const signUpSchema = object({
  agreement: z.boolean(),
  privacy: z.boolean(),
})
type signUpInput = TypeOf<typeof signUpSchema>;

type PolicyProps = {
  setPolicy: Dispatch<SetStateAction<string>>,
  setPrivacyPolicy: Dispatch<SetStateAction<boolean>>,
}

const SignUpPrivacyPolicy: React.FC<PolicyProps> = (props) => {
  const native = useNavigate();
  const {t} = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const {register, handleSubmit, formState: {errors}} = useForm<signUpInput>({
    resolver: zodResolver(signUpSchema)
  })

  const {enqueueSnackbar} = useSnackbar()
  const onSignUp = async (data: any) => {
    if(!data.agreement || !data.privacy){
      enqueueSnackbar(t("organ.Please read user agreement and privacy policy before sign up"), {
        variant: "warning",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        }
      })
      return
    }
    try {
      setLoading(true)
      const user = await UserService.signUp(data);
      enqueueSnackbar(t("common.success"), {
        variant: "success",
        autoHideDuration: 1500,
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        }
      })
      native(WebURL.AUTH_USER_LOGIN);
    } finally {
      setLoading(false)
    }
  }
  return (
      <Grid container={true} rowSpacing={2} component={"form"} noValidate sx={{ width: '30vw' }} onSubmit={handleSubmit(onSignUp)}>
        <Grid item xs={12} sx={{display: "inline-flex", flexDirection: "column", marginLeft: -1}}>
          <Typography variant="h5">{t("signUp.Privacy policy")}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ color: "gray"}}>
          {t("signUp.privacyPolicy text1")}</Typography>
          <Typography sx={{ color: "gray"}}>{t("signUp.privacyPolicy text2")}
          {t("signUp.privacyPolicy text3")}</Typography>
          <Typography sx={{ color: "gray"}}>{t("signUp.privacyPolicy text4")}</Typography>
          <Typography sx={{ color: "gray"}}>{t("signUp.privacyPolicy text5")}</Typography>
          <Typography sx={{ color: "gray"}}>{t("signUp.privacyPolicy text6")}</Typography>
        </Grid>
        <Grid item xs={12} sx={{
            display: "inline-flex",
            justifyContent: "center",
            marginTop: "20px"
          }}>
          <Button variant="contained"
                  disableElevation
                  fullWidth={true}
                  sx={{textTransform: "none" }}
                  onClick={() => {props.setPolicy("main"); props.setPrivacyPolicy(true);}}>
            {t("signUp.Read and agree")}
          </Button>
        </Grid>
        <Grid item xs={12} sx={{
            display: "inline-flex",
            justifyContent: "center"
          }}>
          <Button variant="outlined"
                  disableElevation
                  fullWidth={true}
                  sx={{textTransform: "none" }}
                  onClick={() => {props.setPolicy("main"); props.setPrivacyPolicy(false);}}>
            {t("signUp.Not agree and quit")}
          </Button>
        </Grid>
      </Grid>
  )
}
export default SignUpPrivacyPolicy
